/* 🤖 this file was generated by svg-to-ts */
export const matIconNature: {
  name: 'nature';
  data: string;
} = {
  name: 'nature',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 16.12h-.03c3.49-.4 6.2-3.36 6.2-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0 0 11 16.06V20H5v2h14v-2h-6v-3.88zM7.17 9.17c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5z"/></svg>`
};
